import { useEffect, useState } from "react";
import Notification from "../../../../components/toast";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { schema, schemaDefaultValues } from "./schema";

export const IndexHook = ({
	isOpenModalRegister,
	ident,
	idTable,
	selectedData,
	setSelectData,
	fetchID,
	reloadData,
	insert,
}) => {
	const {
		register,
		handleSubmit,
		setValue,
		setFocus,
		watch,
		reset,
		control,
		formState: { errors, isSubmitting },
	} = useForm({
		mode: "onSubmit",
		//quando revalidar os campos
		resolver: zodResolver(schema),
		defaultValues: schemaDefaultValues,
	});

	// const [id_forma, setid_forma] = useState(0);

	const [loading, setLoading] = useState(false);
	const [apiKey, setApiKey] = useState("");
	const [url, setUrl] = useState("");

	// Monitorar o campo 'descricao' usando watch

	const instancia = watch("descricao");
	const telefone = watch("telefone");
	const id_whatsapp = watch("id_whatsapp");

	const handleCloseModalRegister = () => {
		const event = new CustomEvent(`${ident}`);
		window.dispatchEvent(event);
	};

	//#region Fetch
	useEffect(() => {
		if (isOpenModalRegister) {
			const id =
				typeof selectedData[idTable] === "number" && !isNaN(selectedData[idTable]) ? selectedData[idTable] : 0;

			if (id > 0) {
				fetch(id);
			}
		} else {
			if (setSelectData) setSelectData({});

			reset();
		}
	}, [isOpenModalRegister, selectedData]);

	const fetch = async (id) => {
		try {
			setLoading(true);

			const response = await fetchID(id);

			if (response.data && typeof response.data === "object") {
				const data = response.data;

				// const newData = await processNewData(data);

				Object.keys(data).forEach((field) => {
					setValue(field, data[field]);
				});
			}
		} catch (error) {
			Notification.showToast({
				message: error.message,
				type: "warning",
			});
		} finally {
			setLoading(false);
		}
	};

	// const processNewData = async (data) => {
	// 	return {
	// 		...data,
	// 		ativo: LibBoolean.strToBoolean(data.ativo),
	// 	};
	// };
	//#endregion

	//#region onSubmit
	const handleOnSubmit = async (data) => {
		try {
			let response;

			// const newDate = ValidateSubmit(data);

			response = await insert(data);

			const currentId = response.data[idTable];

			await reloadData(data[idTable], currentId);

			Notification.showToast({
				message: "Registro salvo com sucesso.",
				type: "success",
			});
			fetch(currentId);
			// reset();
			// handleCloseModalRegister();
		} catch (error) {
			if (
				error.message &&
				typeof error.message === "string" &&
				error.message.toLowerCase().includes("id_empresa") &&
				error.message.toLowerCase().includes("duplicado")
			) {
				Notification.showToast({
					message: "Ops! Essa descrição já foi usada. Tente outra, por favor.",
					type: "warning",
				});
				return;
			} else {
				Notification.showToast({
					message: error.message,
					type: "error",
				});
			}
		}
	};

	const handleOnError = (errors) => {
		Notification.showToast({
			message: "Preencha os campos obrigatórios antes de salvar",
			type: "warning",
		});
	};

	//#endregion

	return {
		//hooks
		handleOnSubmit,
		handleCloseModalRegister,

		instancia,
		id_whatsapp,
		telefone,

		//useForm
		register,
		handleSubmit,
		setValue,
		control,
		setFocus,

		handleOnError,

		loading,
		//formState
		errors,
		isSubmitting,
	};
};
